import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { CTA } from './CTA'
import { FAQsSlice } from './types'
import { HomePagePrismicText } from '../../components/HomePagePrismicText/HomePagePrismicText'
import { PrismicAccordion } from '@app/prismic/src/components/PrismicAccordion/PrismicAccordion'
import { getCTAHref } from '../../utils/getCTAHref'
import { styled } from '@mui/material'
import { useComponentOnScreen } from '../../hooks/useComponentOnScreen'
import { useEffect, useRef } from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'

const twoColumnLayout = `
  "title faqs"
  "ctas faqs"
`

const singleColumnLayout = `
  "title"
  "faqs"
  "ctas"
`

/** One off styles for the FAQ accordion in the homepage */
const HomepagePrismicAccordionWrapper = styled(Box)(({ theme }) => ({
  gridArea: 'faqs',
  ['.MuiAccordionDetails-root']: {
    color: theme.builder.space30
  }
}))

export const FAQs = ({ primary, items }: FAQsSlice): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null)
  const componentIsVisible = useComponentOnScreen(ref)
  useEffect(() => {
    if (componentIsVisible) {
      events.Revenue_HomepageV1_ScrolledTo_Section('faqs')
    }
  }, [componentIsVisible])
  const accordionItems = items.map(item => ({ title: item.question, description: item.answer }))

  return (
    <Box
      component="section"
      sx={{
        display: 'grid',
        gridTemplateAreas: { xs: singleColumnLayout, md: twoColumnLayout },
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: { xs: '40px', md: '40px', lg: '80px' },
        padding: {
          xs: '40px 20px',
          md: '80px 40px',
          xl: '120px 80px'
        },
        backgroundColor: '#F6F3EF'
      }}
      ref={ref}
    >
      <HomePagePrismicText
        variant="display/large"
        richTextField={primary.heading}
        sx={{ margin: 0, gridArea: 'title' }}
      />
      <Box
        sx={{
          gridArea: 'ctas',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
          gap: '24px'
        }}
      >
        <CTA
          img={primary.cta1_img}
          line1={primary.cta1_line1}
          line2={primary.cta1_line2}
          trackLinkClick={() => {
            events.Revenue_HomepageV1_Clicked_FAQTalkWithAnExpert(getCTAHref(primary.cta1_line2))
          }}
        />

        <CTA
          img={primary.cta2_img}
          line1={primary.cta2_line1}
          line2={primary.cta2_line2}
          trackLinkClick={() => {
            events.Revenue_HomepageV1_Clicked_FAQVisitHelpcenter(getCTAHref(primary.cta2_line2))
          }}
        />
      </Box>
      <HomepagePrismicAccordionWrapper>
        <PrismicAccordion items={accordionItems} shouldItemsStartExpanded={true} />
      </HomepagePrismicAccordionWrapper>
    </Box>
  )
}
